import { FC, PropsWithChildren } from "react";
import { FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorsDisplayContainer } from "@ryde/controls";

import {
  FormContentStaticStyled,
  LayoutRightCrudContentStyled,
} from "./layout.right.crud.content.styled";
import { LayoutRightLoader } from "./partials";

interface ILayoutRightCrudContentStatic extends PropsWithChildren {
  serverErrors?: string[];
  formErrors?: FieldErrors | undefined;
  loading?: boolean;
  /** Drops the top spacing so the content starts flush with the scroll area (sticky headers). */
  isFlush?: boolean;
}

export const LayoutRightCrudContentStatic: FC<
  ILayoutRightCrudContentStatic
> = ({ children, serverErrors, formErrors, loading, isFlush }) => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorsDisplayContainer
        serverErrors={serverErrors}
        formErrors={formErrors}
      />
      <LayoutRightCrudContentStyled>
        <FormContentStaticStyled $isFlush={isFlush}>
          {children}
        </FormContentStaticStyled>
      </LayoutRightCrudContentStyled>
      {loading && (
        <LayoutRightCrudContentStyled>
          <LayoutRightLoader>{t(`ui.LOADING_DATA`)}</LayoutRightLoader>
        </LayoutRightCrudContentStyled>
      )}
    </>
  );
};
